import React from 'react';
import { BrandsAPI } from '../../../../../../constructs/brands/interface';
import { useAPIContext } from '../../../../context/api';
import { AnyCreativityConfig, CreativityType } from '../../../../types/banner';
import { getClientHandler } from '../../../../handlers';
import { useClientId } from '../../../use-client-id';

export const useCreateFormBanner = () => {
  const { callEndpoint } = useAPIContext();
  const clientId = useClientId();
  const clientHandler = getClientHandler(clientId);

  const createFormBanner = React.useCallback(
    async (
      creativityType: CreativityType,
      creativityConfig: AnyCreativityConfig,
      title: string,
      templateFamily?: string
    ) => {
      let fileNamingPrefix = undefined;

      if (clientHandler.getFileNaming) {
        fileNamingPrefix = clientHandler.getFileNaming(
          { ...creativityConfig, _creativityType: creativityType },
          creativityType
        );
      }

      try {
        const res = await callEndpoint<BrandsAPI, 'create-creativity-banner'>('brands', '/creativities', 'POST', {
          creativityType,
          creativityConfig,
          title,
          templateFamily,
          fileNamingPrefix
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error: any) {
        console.error('Error al crear el banner:', error);
        return null;
      }
    },
    [callEndpoint, clientHandler]
  );

  return { createFormBanner };
};
